module.exports = __webpack_public_path__ + "static/loja_1-dc8fdf07e9e2f3bc8e5dbc340b66c76e.png";